import { Button, Stack, Typography, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

type Props = {
	icon: LucideIcon;
	title: string;
	description: string;
	actionLabel: string;
	onAction: () => void;
};

export const CenteredEmptyState: FC<Props> = ({
	icon: Icon,
	title,
	description,
	actionLabel,
	onAction,
}) => {
	const theme = useTheme();

	return (
		<Stack
			alignItems="center"
			justifyContent="center"
			px={theme.spacingTokens.xxl}
			py={6.4}
		>
			<IconBox
				bg={theme.palette.grey[100]}
				size={64}
				borderRadius={theme.radii.xl}
				mb={theme.spacingTokens.lg}
			>
				<Icon size={28} color={theme.palette.grey[400]} />
			</IconBox>
			<Typography variant="h4" textAlign="center" mb={theme.spacingTokens.xs}>
				{title}
			</Typography>
			<Typography variant="body2" textAlign="center" lineHeight={1.6}>
				{description}
			</Typography>
			<Button
				variant="textLink"
				onClick={onAction}
				sx={{ mt: theme.spacingTokens.md }}
			>
				{actionLabel}
			</Button>
		</Stack>
	);
};
